/**
 * ID-006 remediation: allowlist Seqera endpoints and reject SSRF targets.
 *
 * Used by both the back-end lambda and the Zod schemas in shared-lib; must stay
 * dependency-free and environment-neutral (only relies on the URL global which
 * is available in browsers and Node ≥10).
 */

const PRIVATE_HOST_PATTERNS: RegExp[] = [
  /^127\./,
  /^10\./,
  /^172\.(1[6-9]|2\d|3[01])\./,
  /^192\.168\./,
  /^169\.254\./,
  /^localhost$/i,
  /^0\.0\.0\.0$/,
  /^metadata(\.|$)/i,
];

export function isAllowedSeqeraEndpoint(value: string | undefined | null): boolean {
  if (!value) return false;

  let parsed: URL;
  try {
    parsed = new URL(value);
  } catch {
    return false;
  }

  if (parsed.protocol !== 'https:') return false;

  const host = parsed.hostname.toLowerCase();

  if (PRIVATE_HOST_PATTERNS.some((re) => re.test(host))) return false;

  if (host === 'api.cloud.seqera.io') return true;
  if (host.endsWith('.seqera.io')) return true;

  return false;
}
